(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["as-pdp-bottom"] && !Shopify.designMode) return;
  try {
    /* <as-desc> V2.6: oculta en la descripción los puntos que ya salen con foto en «Por qué te va a encantar» (misma regla: primera lista, o líneas con ✔/✅; máx. data-max; mínimo 2). Si no está seguro de que coinciden, no oculta nada. */
  if(!customElements.get('as-desc')){
    customElements.define('as-desc', class extends HTMLElement{
      connectedCallback(){
        if(this._done) return; this._done=1;
        try{
          var mode=this.dataset.dup, max=parseInt(this.dataset.max,10)||3, r=this.querySelector('.asd-desc__rte');
          if(!r||!mode) return;
          var hide=function(e){ e.style.display='none'; };
          var txt=function(e){ return ((e&&e.textContent)||'').replace(/\s+/g,' ').trim(); };
          var isHead=function(e){ var t=txt(e); return !!e && t.length>0 && t.length<=80 && /:$|encant|caracter|destac|beneficio|por qu/i.test(t); };
          var all=[], picked=[], i;
          var isDupHead=function(e){ var t=txt(e); return !!e && t.length>0 && t.length<=80 && /encant/i.test(t); };
          if(mode==='li'){
            var ul=r.querySelector('ul'); if(!ul) return;
            all=[].filter.call(ul.children,function(e){ return e.tagName==='LI'; });
            for(i=0;i<all.length&&picked.length<max;i++){ if(txt(all[i]).length>=3) picked.push(all[i]); }
            if(picked.length<2) return;
            var pv=ul.previousElementSibling;
            picked.forEach(hide);
            if(picked.length===all.length){ hide(ul); if(isHead(pv)) hide(pv); } else if(isDupHead(pv)) hide(pv);
          } else {
            var CK=/[✔✅]/g, segs=[];
            [].forEach.call(r.querySelectorAll('p,li,div,h3,h4'),function(el){
              if(el.querySelector('p,li,div,h3,h4')||!/[✔✅]/.test(el.textContent||'')) return;
              var cur={nodes:[],br:null,el:el};
              [].slice.call(el.childNodes).forEach(function(n){ if(n.nodeName==='BR'){ cur.br=n; segs.push(cur); cur={nodes:[],br:null,el:el}; } else cur.nodes.push(n); });
              segs.push(cur);
            });
            var lines=segs.filter(function(g){ g.t=g.nodes.map(function(n){ return n.textContent||''; }).join('').replace(/\s+/g,' ').trim(); return /^[✔✅]/.test(g.t); });
            var total=((r.textContent||'').match(CK)||[]).length;
            if(!lines.length||lines.length!==total||lines.some(function(g){ return (g.t.match(CK)||[]).length!==1; })) return;
            for(i=0;i<lines.length&&picked.length<max;i++){ if(lines[i].t.replace(/[✔✅️]/g,'').trim().length>=3) picked.push(lines[i]); }
            if(picked.length<2) return;
            var pv2=picked[0].el.previousElementSibling, els=[];
            picked.forEach(function(g){ var sp=document.createElement('span'); sp.style.display='none'; g.el.insertBefore(sp,g.nodes[0]); g.nodes.forEach(function(n){ sp.appendChild(n); }); if(g.br) hide(g.br); if(els.indexOf(g.el)<0) els.push(g.el); });
            els.forEach(function(el){ var left=segs.filter(function(g){ return g.el===el && picked.indexOf(g)<0 && g.nodes.some(function(n){ return (n.textContent||'').trim()!==''; }); }); if(!left.length) hide(el); });
            if(picked.length===lines.length){ if(isHead(pv2)) hide(pv2); } else if(isDupHead(pv2)) hide(pv2);
          }
        }catch(e){}
      }
    });
  }
  /* <as-eta>: recalcula en el navegador la entrega estimada (7-14 días laborables, sin fines de semana ni festivos de data-h).
     Si pedir hoy da una fecha distinta que pedir mañana, muestra el tiempo REAL que queda hasta medianoche; si no, «Pide hoy».
     Se reaplica sola si el tema vuelve a pintar el bloque (cambio de variante / carrito) y cada 20 s. */
  if(!customElements.get('as-eta')){
    (function(){
      var DN=['dom','lun','mar','mié','jue','vie','sáb'], MN=['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
      var pad=function(x){return (x<10?'0':'')+x;};
      var iso=function(d){return d.getFullYear()+'-'+pad(d.getMonth()+1)+'-'+pad(d.getDate());};
      var fmt=function(x){return DN[x.getDay()]+' '+x.getDate()+' '+MN[x.getMonth()];};
      var win=function(h,base){
        var d=new Date(base.getFullYear(),base.getMonth(),base.getDate(),12,0,0), n=0, f=null, t=null;
        for(var i=0;i<60&&!t;i++){
          d.setDate(d.getDate()+1);
          var w=d.getDay(); if(w===0||w===6||h.indexOf(iso(d))>-1) continue;
          n++; if(n===7) f=fmt(d); if(n===14) t=fmt(d);
        }
        return (f&&t)?[f,t]:null;
      };
      var OPT={childList:true,subtree:true,characterData:true};
      customElements.define('as-eta', class extends HTMLElement{
        connectedCallback(){
          var s=this; s.upd();
          if(!s._i) s._i=setInterval(function(){ s.upd(); },20000);
          if(!s._mo && window.MutationObserver){ s._mo=new MutationObserver(function(){ clearTimeout(s._t); s._t=setTimeout(function(){ s.upd(); },40); }); s._mo.observe(s,OPT); }
        }
        disconnectedCallback(){ clearInterval(this._i); this._i=null; if(this._mo){ this._mo.disconnect(); this._mo=null; } }
        upd(){
          var mo=this._mo; if(mo) mo.disconnect();
          try{
            var h=(this.dataset.h||'').split(','), now=new Date(), tm=new Date(now.getFullYear(),now.getMonth(),now.getDate()+1,12,0,0);
            var a=win(h,now), b=win(h,tm); if(!a) return;
            var bf=this.querySelector('[data-f]'), bt=this.querySelector('[data-t]'), pre=this.querySelector('[data-pre]');
            if(bf&&bf.textContent!==a[0]) bf.textContent=a[0];
            if(bt&&bt.textContent!==a[1]) bt.textContent=a[1];
            if(pre){
              var html='Pide hoy';
              if(b&&(b[0]!==a[0]||b[1]!==a[1])){
                var mid=new Date(now.getFullYear(),now.getMonth(),now.getDate()+1,0,0,0).getTime();
                var m=Math.max(1,Math.ceil((mid-now.getTime())/60000)), hh=Math.floor(m/60), mm=m%60;
                html=hh>0?'Pide en las próximas <b>'+hh+' h'+(mm?' '+mm+' min':'')+'</b>':'Pide en los próximos <b>'+mm+' min</b>';
              }
              if(pre.innerHTML!==html) pre.innerHTML=html;
            }
          }catch(e){}
          finally{ if(mo){ mo.takeRecords(); mo.observe(this,OPT); } }
        }
      });
    })();
  }
  } catch(e) { console.error(e); }
})();

})();
